import { onExpandModeReady } from './onExpandModeReady';
import model from './model';

export default model.createController(({ $bind, $widget, flowAPI }) => {
  return {
    pageReady: ($w) => onExpandModeReady($w, flowAPI, $widget.props),
    exports: {},
  };
});
